import { ClassPrefix, CollapsedBreakpoints, GridBehavior, HorizontalAllTimes, MaxContainerWidth } from "../../../../Constant";
import { CLASS_PREFIX, CONTAINER_WIDTH, REST_GRID } from "../../../../Data/UiKit/Grid";

export const GridOptionTableBody = () => {
  return (
    <tbody>
      <tr>
        <th className="text-nowrap" scope="row">{GridBehavior}</th>
        <td>{HorizontalAllTimes}</td>
        <td colSpan={5}>{CollapsedBreakpoints}</td>
      </tr>
      <tr>
        <th className="text-nowrap" scope="row">{MaxContainerWidth}</th>
        {CONTAINER_WIDTH.map((item, index) => (
          <td key={index}>{item}</td>
        ))}
      </tr>
      <tr>
        <th className="text-nowrap" scope="row">{ClassPrefix}</th>
        {CLASS_PREFIX.map((item, index) => (
          <td key={index}><code>{item}</code></td>
        ))}
      </tr>
      {REST_GRID.map(({ title, td }, index) => (
        <tr key={index}>
          <th className="text-nowrap" scope="row">{title}</th>
          <td colSpan={6}>{td}</td>
        </tr>
      ))}
    </tbody>
  );
};
